<div class="login-wrapper reset-password">
  <form class="login" #resetPasswordForm="ngForm" (ngSubmit)="onSubmit()">
    <div class="login-group" (capsLock)="capsOn=$event">
      <div class="inner-addon right-addon">
        <div>
          <i alt="show" class="far fa-eye eye-show" (click)="showPassword = !showPassword" [class.hide]="showPassword"></i>
          <i alt="hide" class="far fa-eye-slash eye-hide" (click)="showPassword = !showPassword" [class.hide]="!showPassword"></i>
        </div>
        <input #password class="password" [type]="showPassword ? 'text' : 'password'" name="password" placeholder="{{ 'USER.PASSWORD' | translate }}" [(ngModel)]="model.password" required />
        <div>
          <i alt="show" class="far fa-eye eye-show" (click)="showRepeatPassword = !showRepeatPassword" [class.hide]="showRepeatPassword"></i>
          <i alt="hide" class="far fa-eye-slash eye-hide" (click)="showRepeatPassword = !showRepeatPassword" [class.hide]="!showRepeatPassword"></i>
        </div>
        <input class="password" [type]="showRepeatPassword ? 'text' : 'password'" name="confirm-password" placeholder="{{ 'USER.REPEAT_PASSWORD' | translate }}" [(ngModel)]="model.confirmPassword" required />
      </div>
      <div>
        <img class="warning-image" *ngIf="capsOn" src="../../../assets/images/warningCapsLock.png"/>
        <span *ngIf="capsOn">{{ 'USER.CAPS_LOCK_WARNING' | translate }}</span>
      </div>
      <clr-alert *ngIf="errorMessage" [clrAlertType]="'danger'" [clrAlertClosable]="false">
        <div class="alert-item">
          <span class="alert-text">{{errorMessage}}</span>
        </div>
      </clr-alert>
      <clr-alert *ngIf="successMessage" [clrAlertType]="'success'" [clrAlertClosable]="false">
        <div class="alert-item">
          <span class="alert-text">{{successMessage}}</span>
        </div>
      </clr-alert>
      <button type="submit" class="btn btn-primary" [disabled]="!resetPasswordForm.form.valid">{{ 'LOGIN.RESET_PASSWORD' | translate }}</button>
    </div>
  </form>
</div>

